/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function OpenAPI({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}><g stroke="currentColor" strokeWidth={1.2}><circle cx={8.5} cy={8} r={2} /><circle cx={13.563} cy={2.938} r={2} /><path d="m9.875 6.625 2.688-2.688" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.5 8a7 7 0 1 1-7-7" /></g></svg>;
}
;